class OpenAIService {
  constructor() {
    this.apiKey = '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';
    this.baseUrl = 'https://api.openai.com/v1';
  }

  async generateResponse(message) {
    try {
      const systemPrompt = `You are the AI assistant for Carson Exports, a premier used car dealership in Dartmouth, Nova Scotia.
      
      Dealership Stats:
      - Location: 550 Windmill Rd, Dartmouth
      - Rating: 4.8 stars (990 Google Reviews)
      - Phone: 1-833-706-3089
      - Specialization: High-quality used trucks, SUVs, and sedans.
      
      Guidelines:
      - Be friendly, professional, and helpful.
      - We offer financing for all credit types.
      - We take trade-ins.
      - Mention our location in Dartmouth if asked about where we are.
      - If users ask about a specific car type (truck, SUV), highlight that we carry various makes (Ford, Honda, Toyota, BMW, etc.).
      
      Inventory Context: We have Ford F-150s, Honda Civics, Toyota RAV4s, and luxury options like BMW X5s.`;

      const response = await fetch(`${this.baseUrl}/chat/completions`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${this.apiKey}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          model: 'gpt-3.5-turbo',
          messages: [
            { role: 'system', content: systemPrompt },
            { role: 'user', content: message }
          ],
          max_tokens: 400,
          temperature: 0.7,
        }),
      });

      if (!response.ok) throw new Error('API Error');
      const data = await response.json();
      return data.choices[0].message.content;
    } catch (error) {
      return "Welcome to Carson Exports in Dartmouth! I'm here to help you find the perfect used vehicle. How can I assist you today?";
    }
  }
}

export default new OpenAIService();